// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"OfferingSpecificPageOptions_Wrapper__2VLz0","OptionLabel":"OfferingSpecificPageOptions_OptionLabel__1gpn3"};